import React, { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

function loadRazorpay() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

export default function PaywallModal({ onClose, onSuccess, feature = "Pro Studio" }) {
  const [loading, setLoading] = useState(false);

  const handlePay = async () => {
    setLoading(true);
    const ok = await loadRazorpay();
    if (!ok) { toast.error("Failed to load payment gateway"); setLoading(false); return; }
    try {
      const { data: order } = await api.post("/payments/create-order", { amount: 49900, plan: "pro_lifetime" });
      const rzp = new window.Razorpay({
        key: order.key_id,
        amount: order.amount,
        currency: order.currency,
        order_id: order.order_id,
        name: "Resume Studio",
        description: "Pro Studio — Lifetime",
        theme: { color: "#0047AB" },
        method: { upi: true, card: true, netbanking: true, wallet: true },
        handler: async (resp) => {
          try {
            await api.post("/payments/verify", {
              razorpay_order_id: resp.razorpay_order_id,
              razorpay_payment_id: resp.razorpay_payment_id,
              razorpay_signature: resp.razorpay_signature,
            });
            onSuccess?.();
          } catch (e) {
            toast.error("Payment verification failed");
          }
        },
        modal: { ondismiss: () => setLoading(false) },
      });
      rzp.on("payment.failed", () => { toast.error("Payment failed"); setLoading(false); });
      rzp.open();
    } catch (e) {
      toast.error("Could not start payment");
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="paywall-modal">
      <div className="absolute inset-0 bg-black/60" onClick={onClose} />
      <div className="relative bg-white brut-border brut-shadow-lg max-w-lg w-full p-8">
        <div className="flex items-center justify-between mb-6">
          <div className="label-eyebrow">Unlock · {feature}</div>
          <button onClick={onClose} data-testid="paywall-close" className="brut-border px-2 py-1 text-sm">Close</button>
        </div>
        <h2 className="font-display text-4xl font-black uppercase leading-none">Go Pro.<br/>Keep going Pro.</h2>
        <p className="mt-4 text-neutral-700">One payment. Six studio templates, unlimited photo & certificate uploads, and priority AI drafting.</p>
        <div className="mt-6 bg-[#F4F4F0] brut-border p-6">
          <div className="flex items-baseline justify-between">
            <div>
              <div className="font-display text-5xl font-black">₹499</div>
              <div className="text-neutral-600 text-sm">One-time · Lifetime access</div>
            </div>
            <div className="bg-[#FFD700] text-black label-eyebrow px-2 py-1">UPI · Card · Netbanking</div>
          </div>
        </div>
        <button
          data-testid="pay-now-btn"
          disabled={loading}
          onClick={handlePay}
          className="mt-8 w-full brut-border brut-shadow bg-black text-white px-6 py-4 font-medium disabled:opacity-60"
        >
          {loading ? "Opening checkout…" : "Pay ₹499 with UPI →"}
        </button>
        <div className="mt-4 text-xs text-neutral-500 text-center">Payments secured by Razorpay. Test mode enabled.</div>
      </div>
    </div>
  );
}
